import styled from 'styled-components';
import { renderAlertInPosition } from './positions';
import { colors } from '../../../stylesheets';
import { statusColor } from '../../../utils';
import Card from '../Card/Card';
import { Container } from 'reactstrap';

export const AlertContainerWrapper = styled(Container)`
  ${renderAlertInPosition};
  z-index: 9999999;
`;

const getBg = (status) => {
  const color = statusColor(status);
  return `light${color[0].toUpperCase() + color.slice(1)}`;
};

const AlertContainer = styled(Card)`
  width: 100%;
  min-height: 60px;
  z-index: ${(props) => (props.useStatic ? 1000 : 1100)};
  display: flex;
  align-items: center;
  background-color: ${(props) => colors[getBg(props.status)]};
`;

export default AlertContainer;
